/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Media from 'react-media';
import track from 'react-tracking';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { array, func, object } from 'prop-types';
import MobileGiftListUser from './MobileGiftList/Layouts/MobileGiftListUser';
import DesktopGiftListUser from './DesktopGiftList/Layouts/DesktopGiftListUser';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { trackPage, trackGiftList } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;
class GiftListUser extends React.Component {
    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
        const { handleTrackEvent, emitCustomImpressionTrackingEvent, salesforceAPIResponse } = this.props;
        let filteredCampaign = {};
        handleTrackEvent({
            eventCategory: 'Test Impression',
            eventAction: 'Gift List V1',
            eventLabel: '',
            nonInteraction: '1',
        });

        const filteredProducts = salesforceAPIResponse.reduce((uniqueProducts, campaign) => {
            filteredCampaign = campaign;
            const campaignProduct = campaign.products;
            campaignProduct?.forEach((product) => {
                const filteredProductItem = uniqueProducts.find((item) => item.partNumber === product.partNumber);
                if (!filteredProductItem) uniqueProducts.push(product);
            });
            return uniqueProducts;
        }, []);

        filteredCampaign.products = filteredProducts;
        emitCustomImpressionTrackingEvent({
            action: 'Impression',
            salesforceResponse: filteredCampaign,
            page: { type: 'gift-list' },
            eventSubType: 'campaign-tracking',
        });
    };

    @track(trackGiftList)
    render() {
        const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        return (
            <>
                <Media query={breakpointExpr}>
                    {(matches) => (       // eslint-disable-line arrow-parens
                        matches ? (
                            <>
                                <MobileGiftListUser
                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                    {...this.props}
                                />
                            </>
                        ) : (
                            <>
                                <DesktopGiftListUser
                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                    {...this.props}
                                />
                            </>
                        )
                    )}
                </Media>
            </>
        );
    }
}

GiftListUser.propTypes = {
    handleTrackEvent: func.isRequired,
    salesforceAPIResponse: array,
    emitCustomImpressionTrackingEvent: func,
};

GiftListUser.defaultProps = {
    salesforceAPIResponse: [],
    emitCustomImpressionTrackingEvent: () => { },
};

export const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        salesforceAPIResponse: newState.giftList.salesforceAPIResponse,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleTrackEvent: bindActionCreators(trackEvent, dispatch),
    emitCustomImpressionTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

const enhance = compose(
    trackPage(),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);
export default enhance(GiftListUser);
